import React, { useContext } from "react";
import { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import SimpleContext from "./../context/SimpleContext";
import "./SideBar.css";

const SideBar = () => {
  const context = useContext(SimpleContext);

  let drawerClasses = "side-drawer";
  if (context.sideDrawer) {
    drawerClasses = "side-drawer open";
  }
  //فراخانی وب سرویس شماره های پشتیبانی
  useEffect(()=>{
    context.support()
  },[])

  const handleprofileView = (path) => {
    context.handleCloseSidebar();
    context.handleHistoryPush(path);
  };
  const exitButton = () => {
    context.handleCloseSidebar();
    context.setModalShow(true);
    localStorage.clear();
  };
  const enterButton = () => {
    context.handleCloseSidebar();
    context.handleHistoryPush("/register");
  };

  const goSavabegh = () => {
    context.setShowKfp(false);
    context.setShowApi(true);
    context.handleHistoryPush("/savabegh");
  };


  return (
    <>
      {
      context.UseInFo!==null&&
      Object.values(context.UseInFo).length > 0 && (
   
    <div className={drawerClasses} onTouchMove={context.handleCloseSidebar}>
        <>
          <div className="top_side_drawer">
            <div
              style={{ width: "70%", height: "70%" }}
              className="userImagePlace"
            >
              <img
                src={
                  context.UseInFo.image !== ""
                    ? context.UseInFo.image
                    : "images/placeholder_profile.jpg"
                }
                alt="personalImg"
                className="PersonImg"
              />
            </div>
          </div>

          <div className="side-drawerItems">
            <div className="topItems">
              <p className="drawerItemsp">{context.UseInFo.customerName}</p>

              <p className="drawerItemsp">
                شماره موبایل: {context.UseInFo.mobile}{" "}
              </p>
              <button
                onClick={() => handleprofileView("/profileview")}
                className="FirstButtonn"
              >
                {" "}
                پروفایل کاربر
              </button>
              <button
                onClick={() => goSavabegh()}
                className="FirstButtonn"
              >
                {" "}
                سوابق خرید
              </button>
              <button
                onClick={() => handleprofileView("/chatWithAdmin")}
                className="FirstButtonn"
              >
                گفتگو با پشتیبانی
              </button>
              <br />
              <p className="secondButton" onClick={() => exitButton()}>
                خروج
              </p>
            </div>
            <div className="hardCodes">
              {/* <p className="drawerItemsp">شماره فروش : 33741320-024</p> 
              <p className="drawerItemsp">شماره پشتیبانی : 09127434326</p> */}
              <p className="drawerItemsp">{context.phoneOfSupport.toString()}</p>
            </div>
          </div>

          <Modal show={context.modalShow} centered>
            <div
              style={{ padding: "4%", fontWeight: "bold" }}
              className="text-center"
            >
              <p style={{ margin: "0" }}>
                مطمئن هستید که می خواهید از حساب کاربری خود خارج شوید؟
              </p>
            </div>
            <div
              style={{
                padding: "0",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <button
                className="buttonlogout"
                onClick={() => context.clearLocalStorage()}
              >
                بله
              </button>
              <button
                className="buttonNotlogout"
                onClick={() => context.setModalShow(false)}
              >
                خیر
              </button>
            </div>
          </Modal>
        </>
    </div>
      )}
     </>
  );
};

export default SideBar;
